// extracted by mini-css-extract-plugin
export default {"title":"ErrorPage_title__qrgeG","container":"ErrorPage_container__eEvd+","link":"ErrorPage_link__MobaF","button":"ErrorPage_button__lTMXG"};